module.exports = __webpack_public_path__ + "static/media/companyIcon.6a7259ac.png";